<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn icon fab dark small color="error" v-on="on">
                <v-icon>delete</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-toolbar card dark color="primary">
                <v-btn icon @click.native="toggleDialog" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Excluir</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-title class="headline">Atenção!</v-card-title>
            <v-card-text>
                Esta ação é irreversível. Confirma a exclusão?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="blue darken-1" :disable="removing" :loading="removing" @click="toggleDialog()">Não</v-btn>
                <v-btn flat color="blue darken-1" :disable="removing" :loading="removing" @click="removeItem()">Sim</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import PouchDB from 'pouchdb-browser';

let db = new PouchDB('despesas');

export default {
    name    : 'ExcluirModal',
    props   : {
        id         : {
            type     : String,
            required : true
        },
        route      : {
            type     : String,
            required : true
        },
        doc        : {
            type    : Object
        },
        reloadGrid : Function
    },
    methods : {
        toggleDialog() {
            this.dialog = !this.dialog;
        },
        removeItem() {
            this.removing = true;
            if (this.isOnline && !(this.doc === Object && this.doc.unsync)) {
                const id = (this.doc === Object && this.doc._id) ? this.doc._id : this.id;
                this.$axios.delete(`${this.route}/${id}`).then(response => {
                    this.toggleDialog();
                    window.getApp.snackbar = {
                        show  : true,
                        color : 'green',
                        text  : 'Excluído com sucesso!'
                    };
                    this.reloadGrid();
                }).catch(e => {
                    console.error(e);
                    this.toggleDialog();
                    window.getApp.snackbar = {
                        show  : true,
                        color : 'red',
                        text  : 'Oops... Erro inesperado!'
                    };
                }).finally(() => {
                    this.removing = false;
                });
            } else {
                db.remove(this.doc._id, this.doc._rev);
                this.removing = false;
                this.toggleDialog();
                window.getApp.snackbar = {
                    show  : true,
                    color : 'green',
                    text  : 'Excluído com sucesso!'
                };
                this.reloadGrid();
            }
        }
    },
    data() {
        return {
            dialog   : false,
            removing : false
        };
    },
    // mounted() {}
};
</script>
